/* Memoria: birthstone + ash-colour swatches on collection cards. Clicking a stone shows that variant's photo,
   price and link on the card; the round arrow (data-mj-cs-more) goes to the product page.
   On desktop, hovering a stone previews its photo; leaving the stone restores the chosen photo. */
(function () {
  if (window.mjCardStones) return;
  window.mjCardStones = true;
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-mj-cs-more]');
    if (more) {
      e.preventDefault(); e.stopPropagation();
      var mcard = more.closest('.card-wrapper');
      var link = mcard && mcard.querySelector('a[href*="/products/"]');
      if (link) window.location.href = link.href;
      return;
    }
    var btn = e.target.closest('[data-mj-cs-stone]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var wrap = btn.closest('[data-mj-cs]');
    var card = btn.closest('.card-wrapper');
    wrap.querySelectorAll('[data-mj-cs-stone]').forEach(function (s) { s.classList.toggle('is-on', s === btn); });
    if (!card) return;
    card.classList.add('mj-stone-picked');
    var img = card.querySelector('.card__media .media > img');
    if (img && btn.dataset.img) { img.removeAttribute('srcset'); img.src = btn.dataset.img; }
    card.querySelectorAll('.price .price-item--regular, .price .price-item--sale').forEach(function (p) { p.textContent = btn.dataset.price; });
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = btn.dataset.url; });
  }, true);

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  function cardImg(el) {
    var card = el.closest('.card-wrapper');
    return card && card.querySelector('.card__media .media > img');
  }
  document.addEventListener('mouseover', function (e) {
    var btn = e.target.closest('[data-mj-cs-stone]');
    if (!btn || !btn.dataset.img || btn.contains(e.relatedTarget)) return;
    var img = cardImg(btn);
    if (!img) return;
    var wrap = btn.closest('[data-mj-cs]');
    if (wrap && !wrap.dataset.mjPre) {
      wrap.dataset.mjPre = '1';
      wrap.querySelectorAll('[data-mj-cs-stone]').forEach(function (s) { if (s.dataset.img) (new Image()).src = s.dataset.img; });
    }
    if (!img.dataset.mjBase) { img.dataset.mjBase = img.currentSrc || img.src; img.dataset.mjSrcset = img.getAttribute('srcset') || ''; }
    img.removeAttribute('srcset');
    img.src = btn.dataset.img;
  });
  document.addEventListener('mouseout', function (e) {
    var btn = e.target.closest('[data-mj-cs-stone]');
    if (!btn || btn.contains(e.relatedTarget)) return;
    var img = cardImg(btn);
    if (!img || !img.dataset.mjBase) return;
    var picked = btn.closest('[data-mj-cs]').querySelector('[data-mj-cs-stone].is-on');
    if (picked && picked.dataset.img) { img.src = picked.dataset.img; return; }
    img.src = img.dataset.mjBase;
    if (img.dataset.mjSrcset) img.setAttribute('srcset', img.dataset.mjSrcset);
  });
})();
